/**
 * On-page-style filters
 */

import { fetchItems } from './fetch-items';

const filter = document.querySelector('.filter--dynamic');
if (filter) {
	// cache things
	const clear = filter.querySelector('.filter__all');
	const boxes = filter.querySelectorAll('.filter__box');

	// cache items
	const containerEl = document.querySelector('.filter-items-list');
	// get cpt name
	// const postType = 'foobar';
	const postType = filter.dataset.filterCpt;
	// show all items on load
	fetchItems({ postType, containerEl });
	// prep to store choices (each choice set is a key with an array of selections)
	const choices = {};
	// for each checkbox
	boxes?.forEach((box) => {
		// get associated data and the data's name
		const data = box.nextElementSibling.dataset;
		// bail if we have no data
		if (!data?.tax) return;
		// prep to store this choice set
		choices[data.tax] = [];
		// when this checkbox is changed
		box.addEventListener('change', () => {
			// add or remove this value from the list of choices
			if (box.checked && choices[data.tax].indexOf(data.term) === -1) {
				choices[data.tax].push(data.term);
			} else if (!box.checked) {
				choices[data.tax].splice(
					choices[data.tax].indexOf(data.term),
					1
				);
			}
			// show/hide active/inactive items
			fetchItems({
				postType,
				filters: choices,
				containerEl,
			});
		});
	});

	// on click of clear all clear all selected boxes
	clear.addEventListener('click', () => {
		boxes.forEach((box) => (box.checked = false));
		// show everything when clicking "clear all"
		fetchItems({ postType, containerEl });
	});
}
